module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "dedication",
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("To my wife, Hazel, truly an "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb1.jpg",
      "width": "56"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To our sons, Craig and Stuart, each of whom is in their own way a "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb2.jpg",
      "width": "48"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("To their wives, Sevinç and Philippa, each of whom is "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb3.jpg",
      "width": "119"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ded2"
  }, [_vm._v("To our grandchildren, Michael, Toby and Christine,")]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_vm._v("each of whom is a "), _c('img', {
    staticClass: "hebrew",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "images/eer-lucas-heb4.jpg",
      "width": "42"
    }
  }), _vm._v(" for us.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e7e6914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-lucas-0005.vue
// module id = 66
// module chunks = 0